'use client';
import React from 'react';

import type { CampaignFormData } from './CampaignBuilderClient';

const objectives = [
  { id: 'obj-launch', value: 'product_launch', label: 'Lancement produit', desc: 'Présenter un nouveau produit ou service', icon: '🚀' },
  { id: 'obj-awareness', value: 'brand_awareness', label: 'Notoriété de marque', desc: 'Augmenter la visibilité et la reconnaissance', icon: '📣' },
  { id: 'obj-engagement', value: 'engagement', label: 'Engagement communauté', desc: 'Stimuler les interactions et la fidélité', icon: '❤️' },
  { id: 'obj-sales', value: 'sales', label: 'Drive to sales', desc: 'Générer des achats et conversions directes', icon: '🛒' },
  { id: 'obj-ugc', value: 'ugc', label: 'Collecte UGC', desc: 'Obtenir du contenu authentique réutilisable', icon: '📱' },
  { id: 'obj-event', value: 'event', label: 'Promotion événement', desc: 'Couvrir ou promouvoir un événement', icon: '🎯' },
];

interface Props { form: UseFormReturn<CampaignFormData>; }

export default function StepObjective({ form }: Props) {
  const { register, watch, setValue, formState: { errors } } = form;
  const selected = watch('objective');

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-700 text-foreground mb-1">Objectif de campagne</h2>
        <p className="text-sm text-muted-foreground">Quel est le principal résultat attendu de cette campagne ?</p>
      </div>

      <div>
        <label className="block text-sm font-600 text-foreground mb-3">
          Choisissez votre objectif <span className="text-negative">*</span>
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {objectives.map((obj) => (
            <button
              key={obj.id}
              type="button"
              onClick={() => setValue('objective', obj.value)}
              className={`flex items-start gap-3 p-4 rounded-xl border text-left transition-all ${
                selected === obj.value
                  ? 'border-primary bg-primary/10' :'border-border hover:border-primary/40 bg-muted/30'
              }`}
            >
              <span className="text-2xl flex-shrink-0">{obj.icon}</span>
              <div>
                <p className={`text-sm font-700 ${selected === obj.value ? 'text-primary' : 'text-foreground'}`}>{obj.label}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{obj.desc}</p>
              </div>
            </button>
          ))}
        </div>
        {errors.objective && <p className="text-xs text-negative mt-2">Veuillez choisir un objectif</p>}
      </div>

      <div>
        <label className="block text-sm font-600 text-foreground mb-1">Détails de l'objectif</label>
        <p className="text-xs text-muted-foreground mb-2">Décrivez plus précisément votre campagne (optionnel)</p>
        <textarea
          {...register('objectiveDetail')}
          rows={3}
          className="w-full bg-input border border-border rounded-lg px-4 py-3 text-sm text-foreground placeholder-muted-foreground outline-none focus:border-primary transition-colors resize-none"
          placeholder="Ex: Lancement du nouveau Galaxy S26 en Algérie, ciblant les jeunes professionnels 25-35 ans..."
        />
      </div>
    </div>
  );
}